/**
 * Shared password-strength rules.
 *
 * Keep in sync with constants/password_rules.py (backend).
 * Both files define the same constraints so the UI checklist
 * and backend validator always agree.
 */

export const PASSWORD_MIN_LENGTH = 8;

export interface PasswordRule {
  label: string;
  test: (pw: string) => boolean;
}

/**
 * Ordered list of password rules shown in the UI checklist.
 * Each entry has a human-readable label and a test function.
 */
export const PASSWORD_RULES: PasswordRule[] = [
  { label: 'At least 8 characters', test: (pw) => pw.length >= PASSWORD_MIN_LENGTH },
  { label: 'Contains a number', test: (pw) => /\d/.test(pw) },
  {
    label: 'Contains uppercase & lowercase',
    test: (pw) => /[a-z]/.test(pw) && /[A-Z]/.test(pw),
  },
];

/** Check whether a password satisfies every rule. */
export function allPasswordRulesMet(password: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(password));
}
